
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 300 51"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.53 2.15l7.56 7.56V20.5L4.4 24.16H.53V2.15zm0 24.96h3.94l3.62 3.62v11.21L.53 49.5V27.11zM32.42.39l-7.56 7.56H9.81L2.25.39h30.17zM2.25 50.81l7.56-7.56h15.4l7.21 7.56H2.25zm31.82-26.65H30.2l-3.69-3.66V9.71l7.56-7.56v22.01zm0 25l-7.56-7.21V30.73l3.62-3.62h3.94v22.05zM79.14 24.16h-3.87l-3.69-3.66V9.71l7.56-7.56v22.01zm0 25.35l-7.56-7.56V30.73l3.62-3.62h3.94v22.4zM90.67 14.39L95 10.06l4.32 4.46v4.18L95 23l-4.32-4.29v-4.32zm0 26.93L95 36.85l4.32 4.32v4.36L95 49.86l-4.32-4.32v-4.22zM110.82 30.73l3.73-3.83 3.83 3.83v11.21l-7.56 7.56V30.73zM142.7.39l-7.56 7.56H120.1L112.54.39h30.16zm-30.16 50.42l7.56-7.56h15.05l7.56 7.56h-30.17zm22.04-28.93l3.8 3.8-3.73 3.76h-14.06l-3.73-3.76 3.8-3.8h13.92zm9.78-1.38l-3.73 3.8-3.83-3.8V9.71l7.56-7.56V20.5zM187.77.39l-7.56 7.56h-15.05L157.6.39h30.17zm-30.16 50.42l7.56-7.56h15.05l7.56 7.56h-30.17zm22.04-28.93l3.8 3.8-3.73 3.76h-14.06l-3.73-3.76 3.8-3.8h13.92zm9.78 2.28h-3.87l-3.69-3.66V9.71l7.56-7.56v22.01zm0 25.35l-7.56-7.56V30.73l3.62-3.62h3.94v22.4zM200.96 14.39l4.32-4.32 4.32 4.46v4.18L205.28 23l-4.32-4.29v-4.32zm0 26.93l4.32-4.46 4.32 4.32v4.36l-4.32 4.32-4.32-4.32v-4.22zM221.1 2.15l7.56 7.56V20.5l-3.83 3.8-3.73-3.8V2.15zm23.77 19.73l3.8 3.8-3.73 3.76h-14.06l-3.73-3.76 3.8-3.8h13.92zm9.77 2.28h-3.87l-3.69-3.66V9.71l7.56-7.56v22.01zm0 25.35l-7.56-7.56V30.73l3.62-3.62h3.94v22.4zM266.17 2.15l7.56 7.56V20.5l-3.83 3.8-3.73-3.8V2.15zM298.06.39l-7.56 7.56h-15.05L267.89.39h30.17zM267.9 50.81l7.56-7.56h15.05l7.56 7.56H267.9zm22.04-28.93l3.8 3.8-3.73 3.76h-14.06l-3.73-3.76 3.8-3.8h13.92zm9.77 27.63l-7.56-7.56V30.73l3.83-3.83 3.73 3.83v18.78z"}})])
          )
        }
      }
    